import {Component, inject, signal} from '@angular/core';
import {fetchAndActivate, getAll, Value,} from "@angular/fire/remote-config";
import {HubRemoteConfigService} from "../services/hub-remote-config-service";

export type RemoteConfigType = {
  key: string;
  value: Value
}

@Component({
  selector: 'app-hub-remote-config',
  imports: [],
  templateUrl: './hub-remote-config.component.html',
  styleUrl: './hub-remote-config.component.css'
})
export class HubRemoteConfigComponent {

  selectedRemoteConfig = signal(null);

  config = inject(HubRemoteConfigService);

  remoteConfig = this.config.initialiseRemoteConfig();

  configs: RemoteConfigType[] = [];


  constructor() {
    (async () => {
      await this.getAllValues();
    })()
  }

  async getAllValues() {
    await fetchAndActivate(this.remoteConfig)
    let result = getAll(this.remoteConfig);
    this.configs = Object.entries(result || {}).map(([key, value]) => ({key, value}));
  }
}
